import { injectIntl } from "react-intl";
import { connect } from "react-redux";

import { setPlanMeta } from "../../../../store/plan/actions";
import { post, get } from "../../../../actions/general";

import Opus from "./Opus";

export default injectIntl(connect(null, { setPlanMeta, post, get })(Opus));
